<template>
  <div>
    <div :style="labelStyle"
         class="d-f-r file-input">
      <input class="input-text" @input="$emit('input', $event.target.value)" :value="value && value"
             :placeholder="placeholder"/>
      <label class="d-picture-select d-f-r d-fa-c">
        <input
            ref="file-input"
            type="file"
            style="display: none"
            :accept="accept"
            @change="handleChange"
        />
        <span>{{ $t('Browser') }}</span>
      </label>
    </div>
    <error-display :error="message" />
  </div>
</template>

<script>
import FileMixin from "@/mixins/FileMixin";
import ErrorDisplay from "@/components/Common/ErrorDisplay";

export default {
  name: 'FileInput',
  components: {ErrorDisplay},
  props: {
    accept: {
      type: String, default: null
    },
    placeholder: {
      type: String, default: "Select file"
    },
    name: String,
    label: String,
    text: String,
    labelStyle: String,
    value: {
      default: null,
    },
    state: {},
    multiple: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
      default: Array
    }
  },
  mixins: [FileMixin],
  data() {
    return {
      loading: false
    }
  },
  computed: {
    message() {
      return this.errors && this.errors.length > 0 ? this.errors.join(", ") : null
    },
    stateClass() {
      return this.message === null
          ? 'd-input-info'
          : !this.message
              ? 'd-input-success'
              : 'd-input-error'
    },
  },
  methods: {
    async handleChange(files) {
      const res = await this.upload(files)
      this.$emit('input', res.path)
    }
  }
};
</script>
<style scoped>
.file-input {
  background: white;
  min-height: 38px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;

}


.d-picture-select {
  border-radius: 0 4px 4px 0;
  width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  margin: 0;
  background: #e5e5e5;
  color: grey;
}

.input-text {
  border: none;
  flex: 1;
  padding: 4px 8px;
  border-radius: 4px;
}

.file-input:focus-within {
  outline: #c8c8c8 solid 2px;
}


.d-input-error {
  border: 1px solid #F64E60 !important;
}

.d-input-success {
  border: 1px solid #1BC5BD !important;
}

.d-input-info {
  border: 1px solid #E4E6EF !important;
}
</style>


